import React, { Component } from 'react';

import FormField from '../../style/styledComponents/FormField';
import FormButton from '../../style/styledComponents/FormButton';
import BoxSize from '../../style/styledComponents/BoxSize';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { verifyNumber } from '../../_redux/actions/vivoUser';
import vivo from '../../_redux/actions/api/vivoUser';
import Icons from '../../style/styledComponents/Icons';

import Header from '../../Components/Header';
import NavBtn from '../../Components/NavBtn';
import LoadingB from '../../Components/LoadingBeneficiario';

import { setWaitCampaign } from '../../_redux/actions/campaign';
import InputMask from 'react-input-mask';

import VivoHome from '../../img/vivohome.svg';
import VivoLogo from '../../img/logo_vivo2x.png';

import { FiAlertCircle } from 'react-icons/fi';
import { FaExclamation } from 'react-icons/fa';

import stores from '../../utils/stores';
import { ThemeProvider } from 'styled-components';
import ThemeSelector from '../../style/themes/ThemeSelector';
import TitleSubscriber from '../../style/styledComponents/TitleSubscriber';

class HomeVivo extends Component {
	constructor(props) {
		super(props);

		this.state = {
			inputData: {
				phone: '',
				loja: null
			},
			hasError: false,
			isComplete: false,
			errorOnField: {},
			title: '',
			error: '',
			loading: false
		};

		this.setField = this.setField.bind(this);
		this.validateField = this.validateField.bind(this);
		this.clearErrorOnFocus = this.clearErrorOnFocus.bind(this);
		this.handleIsComplete = this.handleIsComplete.bind(this);
		this.sendCode = this.sendCode.bind(this);
		this.clearError = this.clearError.bind(this);
		this.isComplete = this.isComplete.bind(this);
	}

	componentWillMount() {
		let { VivoUser } = this.props;
		let vivo = VivoUser.data;
		let inputData = { ...this.state.inputData };
		inputData['phone'] = vivo.phone;

		if (vivo.phone) {
			this.setState({
				inputData,
				isComplete: true
			});
		}
	}

	async componentDidMount() {
		if (window.jQuery) {
			let $ = window.jQuery;
		}
		sessionStorage.setItem('store', stores.vivoavulso);
		await vivo.loginVivo();
	}
	setField(e) {
		let value = e.target.value;
		let name = e.target.getAttribute('name');

		if (name === 'phone') {
			this.setState({
				phoneUnformatted: value
			});
			value = value
				.replace(/( )+/g, '')
				.replace(/_$/g, '')
				.replace('(', '')
				.replace(')', '')
				.replace('-', '');
			value = value;
		}
		let inputData = { ...this.state.inputData };
		inputData[name] = value;
		this.setState({
			inputData
		});

		this.handleIsComplete(value, 'phone');
	}
	clearErrorOnFocus(field) {
		this.setState({
			errorOnField: {
				...this.state.errorOnField,
				[field]: null
			}
		});
	}

	validateField(e, field) {
		const errorMsgs = {
			phone: 'Telefone inválido'
		};
		let value = e.target.value;
		value = value
			.replace(/( )+/g, '')
			.replace(/_$/g, '')
			.replace('(', '')
			.replace(')', '')
			.replace('-', '');
		const isValid = this.checkField(field, value);

		if (isValid) {
			this.setState({
				errorOnField: { ...this.state.errorOnField, [field]: null },
				isComplete: true
			});
		} else {
			this.setState({
				errorOnField: {
					...this.state.errorOnField,
					[field]: errorMsgs[field]
				}
			});
		}

		this.handleIsComplete(value, 'phone');

		//if (!this.state.hasMoreThanOneSub) {
		//}
	}
	handleIsComplete(e, field) {
		const isIncomplete = this.checkField(field, e);
		if (isIncomplete) {
			this.setState({
				isComplete: true
			});
		} else {
			this.setState({
				isComplete: false
			});
		}
	}

	checkField(name, value) {
		let isValidField = false;
		let checkField = {
			phone: /^([0-9]{2})([0-9]{9})$/
		};

		if (checkField[name].test(value) && value[2] === '9') {
			isValidField = true;
		} else isValidField = false;

		return isValidField;
	}

	sendCode() {
		//let loja = this.props.match.params;
		let loja = 'vivoavulso';
		this.setState({
			loading: true
		});
		var result = this.props.verifyNumber(this.state.inputData.phone);
		result.then(valor => {
			if (valor === false) {
				this.setState({
					loading: false
				});
				let phone = this.state.phoneUnformatted;
				this.props.history.push({
					pathname: process.env.PUBLIC_URL + `/${loja}/auth`,
					search: '',
					number: { phone }
				});
			} else if (valor === true) {
				let { VivoUser } = this.props;
				this.setState({
					hasError: true,
					loading: false,
					title: 'Ops!',
					error: VivoUser.data.message
				});
				//TODO fazer a separação de erro do server pro erro de código
			} else if (valor === 'true1') {
				this.setState({
					hasError: true,
					loading: false,
					title: 'Número não habilitado',
					error: `O telefone digitado não tem nenhuma assinatura Yalo. Tente novamente ou acesse: \n`
				});
			}
		});
	}

	clearError() {
		this.setState({
			hasError: null
		});
	}
	isComplete() {
		if (this.state.inputData.phone.length < 12) {
			this.setState({
				errorOnField: {
					...this.state.errorOnField,
					'phone': 'Telefone inválido'
				}
			});
		} else {
		}
	}
	render() {
		let errorElm = null;
		let { VivoUser } = this.props;
		let vivoErrorCode = VivoUser.data.errorCode;
		if (this.state.hasError) {
			errorElm = (
				<div className='overlay'>
					<FormButton className='overlay-box'>
						<BoxSize className='overlay-box--content-epay'>
							<div className='title-alert2'>
								<Icons className='icon-container2'>
									<FaExclamation color={'white'} size={16} />
								</Icons>
								<h2>{this.state.title}</h2>
							</div>
							<p>{this.state.error} </p>
							<div>
								{vivoErrorCode === 'MSO-VIVO-005' ? (
									''
								) : (
									<>
										<small>
											<a
												target='_blank'
												href='https://appstore.vivo.com.br/sc/br/vivostore/detalle/yalo/62759/1990' rel="noreferrer">
												appstore.vivo.com.br
											</a>
										</small>{' '}
									</>
								)}
							</div>
						</BoxSize>
						<div className='overlay-button'>
							<button
								className='overlay-box--close f-bold btn-border-color-ok-epay'
								onClick={this.clearError}>
								TENTAR NOVAMENTE
							</button>
						</div>
					</FormButton>
				</div>
			);
		}
		const pathArray = window.location.pathname.split('/');
		return (
			<ThemeProvider theme={ThemeSelector(pathArray[2])}>
				<div className='page-wrapper'>
					<div className=' footer-adjustment'>
						{errorElm}
						<Header {...this.props} />
						<BoxSize>
							<BoxSize className='content-vivo'>
								<TitleSubscriber className=' visible-xs visible-sm'>
									<h2>Bem-vindo à YALO!</h2>
									<p>
										Sua assinatura está a poucos passos de ser habilitada. Para
										isso, precisamos autenticar sua compra com a VIVO seguindo o
										procedimento abaixo.
									</p>
								</TitleSubscriber>
								<TitleSubscriber className='row  visible-md visible-lg'>
									<h2>Bem-vindo à YALO!</h2>

									<p>
										Sua assinatura está a poucos passos de ser habilitada. Para
										isso, precisamos autenticar sua compra com a VIVO seguindo o
										procedimento abaixo.
									</p>
								</TitleSubscriber>
							</BoxSize>
							<BoxSize className=''>
								<div className='box-content-width'>
									<img
										className='row visible-md visible-lg'
										style={{ width: 200, marginTop: 10 }}
										src={VivoHome}></img>
									<img
										className='row visible-xs visible-sm'
										style={{ width: 150, marginTop: 10 }}
										src={VivoHome}></img>

									<img
										className='row visible-xs visible-sm'
										src={VivoLogo}
										style={{
											width: 100,
											marginTop: 30,
											marginBottom: 30
										}}></img>
									<img
										className='row visible-md visible-lg'
										src={VivoLogo}
										style={{
											width: 100,
											marginTop: 30,
											marginBottom: 30
										}}></img>
									<FormField className=''>
										<div className='form-group2 form-number-phone'>
											<InputMask
												type='text'
												className='form-control2'
												id='telefone'
												required
												name='phone'
												onChange={this.setField}
												onBlur={e => this.validateField(e, 'phone')}
												onFocus={() => this.clearErrorOnFocus('phone')}
												mask='(99) 99999-9999'
												value={this.state.inputData.phone}
											/>

											<label htmlFor='telefone'>Digite seu celular VIVO</label>
											{this.state.errorOnField.phone && (
												<div className='error-msg'>
													<FiAlertCircle size={13} color={'red'} />
													<small className='credit-card-error'>
														{this.state.errorOnField.phone ||
															'Telefone inválido'}
													</small>
												</div>
											)}
										</div>
									</FormField>
									{!this.state.isComplete ? (
										<NavBtn
											disabled={!this.state.isComplete}
											goForward={this.isComplete}
											goForwardText={'SOLICITAR AUTENTICAÇÃO'}
											step={true}></NavBtn>
									) : this.state.loading ? (
										<div className='loading-beneficiario2'>
											<LoadingB type='spin' color='gray' size={25} />
											<span>Carregando...</span>
										</div>
									) : (
										<NavBtn
											disabled={this.state.isLoading}
											goForward={this.sendCode}
											goForwardText={'SOLICITAR AUTENTICAÇÃO'}></NavBtn>
									)}
								</div>
							</BoxSize>
						</BoxSize>
					</div>

					<div className='container-fluid'></div>
				</div>
			</ThemeProvider>
		);
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

const mapDispatchToProps = dispatch =>
	bindActionCreators({ setWaitCampaign, verifyNumber }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HomeVivo);
